import React from 'react';

const Title = ({ value }) => {
  return (
    <h2 className='detail-title'>
      {value}
    </h2>
  )
}

export default Title;
